import { Controller } from 'stimulus'
import { updateOnVolumeDiscountSelected } from '~/site/pages/cart/common'

export default class extends Controller {
  selectDiscount(e) {
    e.preventDefault()
    updateOnVolumeDiscountSelected({
      productId: e.params.productId,
      priceId: e.params.priceId,
    })
  }
}
